import Webcam from './webcam-easy';
import { checkCameraStatus, startCamera } from './webcam-easyV2.js';
let webcam = null;
let isOn = false;

export async function initWebcam(webcamElement, cameraMode, canvasElement, snapSoundElement) {
    webcam = new Webcam(webcamElement, cameraMode, canvasElement, snapSoundElement);
    let status = await webcam.checkCameraStatus();
    return status;
}

export async function initWebcamV2() {
    let status = await checkCameraStatus();
    return status;
}

export function startWebcam(cb) {
    if (webcam) {
        webcam.start()
        .then(result => {
            isOn = true;
            if(cb) cb(result);
        })
        .catch(err => {
            console.error(err);
        });
    }
}
export async function startWebcamV2(webcamElement, cb) {
    const result = await startCamera(webcamElement)
    cb(result)
}

export function stopWebcam() {
    if (webcam) {
        webcam.stop();
        let videos = document.getElementById('video');

        if (videos) {
            for (let i = 0; i < videos.length; i++) {
                if (videos[i] && videos[i].srcObject && videos[i].srcObject.getTracks()) {
                    videos[i].srcObject.getTracks().forEach(function (track) {
                        track.stop();
                    });
                }
            }
        }

        isOn = false;
    }
}
export function stopWebcamV2(webcamElement) {
    if(webcamElement) webcamElement.srcObject.getVideoTracks()[0].stop();
}